// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__yBeOM","large":"styles_large__1g6Q2"};